import React from "react";
import { Box } from "@mui/material";
import { VIEW_MODES } from "../utils/projectViewHelpers";

const OPTIONS = [
  { value: VIEW_MODES.PROJECTS, label: "Projects" },
  { value: VIEW_MODES.SCOPES, label: "Scopes" },
];

export default function ProjectViewToggle({ viewMode, onChange }) {
  return (
    <Box
      sx={{
        display: "inline-flex",
        backgroundColor: "#F2F4F7",
        borderRadius: "6px",
        padding: "3px",
        gap: "3px",
      }}
    >
      {OPTIONS.map(({ value, label }) => {
        const isActive = viewMode === value;
        return (
          <Box
            key={value}
            onClick={() => onChange(value)}
            sx={{
              display: "flex",
              alignItems: "center",
              px: 1.5,
              py: 0.5,
              borderRadius: "4px",
              cursor: "pointer",
              fontSize: "13px",
              fontWeight: 500,
              fontFamily: "Inter Tight",
              transition: "all 0.15s ease",
              backgroundColor: isActive ? "#fff" : "transparent",
              color: isActive ? "#101828" : "#667085",
              boxShadow: isActive ? "0 1px 2px rgba(0,0,0,0.05)" : "none",
              "&:hover": {
                backgroundColor: isActive ? "#fff" : "#E4E7EC",
              },
            }}
          >
            {label}
          </Box>
        );
      })}
    </Box>
  );
}
